export const BORDER_CLASSES = "border-l default-border-color";
